module.exports = __webpack_public_path__ + "img/IMG_1454_L_Wood.c4dfe15d.jpg";